import { FC } from 'react'
import { IonIcon } from '@ionic/react'
import { call } from 'ionicons/icons'
import { AppointmentType, TypeFormEvent } from '../../API'
import ClinicStatusDetails from './ClinicStatusDetails'

interface AppointmentTypeIconProps {
  item?: TypeFormEvent
}

const AppointmentTypeIcon: FC<AppointmentTypeIconProps> = ({ item }) => {
  return (
    <>
      {item?.definitionType === AppointmentType.TELEHEALTH && (
        <span title={item?.definition?.clinicName || ''} className='ion-margin-start' style={{ width: '56px' }}>
          <IonIcon size='large' icon={call} color={!item?.canceled ? 'medium' : ''} />
        </span>
      )}
      {item?.definitionType === AppointmentType.IN_PERSON && (
        <ClinicStatusDetails
          status={item?.definition?.clinicStatus}
          name={item?.definition?.clinicName}
          logoImage={item?.definition?.clinicLogoImage}
        />
      )}
    </>
  )
}

export default AppointmentTypeIcon
